export default __webpack_public_path__ + "static/media/Counter_Completed.a1ca9dfd.mp3";